<div class="verticle-line" [hidden]="isCancelHidden">
    <div [hidden]="isAllBtnHidden">
        <mat-icon
            class="seperator-icon"
            fontSet="fas"
            fontIcon="fa-times-circle"
            aria-hidden="true"
            (click)="iconClicked('cancel')"
        >
        </mat-icon>
    </div>
</div>

<div class="verticle-line" [hidden]="isAddNewHidden">
    <div [hidden]="isAllBtnHidden">
        <mat-icon
            class="seperator-icon"
            fontSet="fas"
            fontIcon="fa-plus-circle"
            aria-hidden="true"
            (click)="iconClicked('addnew')"
        >
        </mat-icon>
    </div>
</div>
